import React, { useState } from 'react';
import InputDialog from '../components/inputDialogBox';
import './Summary.css'
import { Link } from 'react-router-dom';

const ProductTable = () => {
  const underProducts = [
    { brandName: 'Adidas',styleName: 'Stan Smith', color: 'Red', gender: 'Men',sku: 'ABCD12345', category: 'under', underOverUnits: 10 },
  ];

  const overProducts = [
    { brandName: 'New Balance', styleName: '1080v14', color: 'Blue', gender: 'Men', sku: 'ZXCV12345',category: 'over', underOverUnits: 15 },
  ];

  interface Product {
    brandName: string;
    styleName: string;
    sku: string;
    color: string;
    gender: string;
    category: string;
    underOverUnits: number;
  }

  const [showDialog, setShowDialog] = useState(false);
 const [alertTitle, setAlertTitle] = useState('Match');
  const [alertMessage, setAlertMessage] = useState('Enter matching units');
  const changedialog = () => {
  }
  const renderTable = (products: Product[], title: string) => (
    <div style={{ marginBottom: '20px' }}>
      <h3>{title}</h3>
      <table className='summary-table'>
        <thead>
          <tr>
            <th>Brand Name</th>
            <th>Style Name</th>
            <th>SKU</th>
            <th>Color</th>
            <th>Gender</th>
            <th>Under/Over Units</th>
            <th>Match with this</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product: Product, index: number) => (
            <tr key={index}>
              <td>{product.brandName}</td>
              <td>{product.styleName}</td>
              <td>{product.sku}</td>
              <td>{product.color}</td>
              <td>{product.gender}</td>
              <td>{product.underOverUnits}</td>

        <td style={{padding: '8px' }}>
          <Link to={{ pathname: '/product_db', search: `?brandname=${product.brandName}&stylename=${product.styleName}&sku=${product.sku}&color=${product.color}&gender=${product.gender}&selector=${product.category == 'under' ? 'over': 'under'}&units=${product.underOverUnits}`}} >
          <button onClick={changedialog} style={{ padding: '5px 5px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
            Match with this
          </button></Link>
        </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="container-summary">
      <h1>The Summary Table</h1>
      <p>This will be sent on the 15th of every month to each of the retailers</p>
      <div className = "row">
      {renderTable(overProducts, 'Over Summary')}
      {renderTable(underProducts, 'Under Summary')}
      </div>
      {showDialog && (
 <InputDialog
        titler={alertTitle}
        message={alertMessage}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        underover='Under'
      />
      )}
    </div>
  );
};

export default ProductTable;
